import * as Locale from '../../util/Locale.js';
import * as DateUtils from '../DateUtils.ts';

  function handleRecurrencyBy(bys,obj){
    function getter(itemInObj){
      if(typeof obj==='function'){
        return obj(itemInObj)
      }else{
        return obj[itemInObj]
      }
    }
    
    if(bys instanceof Array){
      return bys.map(getter).join(', ');
    }else{
      return getter(bys);
    }
  }
  
  function replacer(options,daysNumber,monthNames,dayNames,relativeNumber){
    return function(g){
      if(g==='$i'){
        return options.interval;
      //jour du mois
      }else if(g==='$d'){
        return handleRecurrencyBy(options.bymonthday,daysNumber);
      //mois
      }else if(g==='$m'){
        return handleRecurrencyBy(options.bymonth,monthNames);
      //jour de la semaine
      }else if(g==='$n'){
        return  handleRecurrencyBy(options.byweekday.map(obj=>obj.n),relativeNumber);
      //jour de la semaine
      }else if(g==='$w'){
        return  handleRecurrencyBy(options.byweekday.map(obj=>(obj.weekday+1)%7),dayNames);
      //jour de la semaine au pluriel, tous les mardi,jeudi
      }else if(g==='$W'){
        return  handleRecurrencyBy(options.byweekday.map(obj=>(obj.weekday+1)%7),dayNames.map(d=> d+"s"));
      }
    }
  }
  function replace(tpl,options,daysNumber,monthNames,dayNames,relativeNumber){
    tpl = tpl.replace(/<([^>]*)>/g,function(all,subRaw){
      var 
        subs = subRaw.split('|');
      
      for(var i=0;i<subs.length;i++){
        var sub = subs[i],useSub = true;
        //we use replace but we do not want the result
        sub.replace(/\$./g,function(g){
          if(g==='$i'){
            useSub &= (options.interval!=null && options.interval!==1);
          }else if(g==='$d'){
            useSub &= (options.bymonthday!=null);
          }else if(g==='$m'){
            useSub &= (options.bymonth!=null);
          }else if(g==='$n'){
            useSub &= (options.byweekday!=null && options.byweekday[0] && relativeNumber[options.byweekday[0].n] != null);
          }else if(g==='$w'){
            useSub &= (options.byweekday!=null);
          }else if(g==='$W'){
            useSub &= (options.byweekday!=null);
          } 
        })
        if(useSub) return sub;
      }
      return "";
      
    })
    return  tpl.replace(/\$./g,replacer(options,daysNumber,monthNames,dayNames,relativeNumber));
  }  
  var byLang = {
    en:function(options){
        var 
        dayNames = DateUtils.getWeekDaysRaw(),
        monthNames = [0].concat( DateUtils.getMonthDaysRaw()),
        daysNumber = function(i){
          if(i<-3) return (-i)+"th last day"; 
          if(i===-3) return "3rd last day"; 
          if(i===-2) return "2nd last day"; 
          if(i===-1) return "last day"; 
          if(i===1) return "1st"; 
          if(i===2) return "2nd"; 
          if(i===3) return "3rd"; 
          else return i+"th"
        },
        relativeNumber = {"1":"1st","2":"2nd","3":"3rd","4":"4th","-1":"last","-2":"2nd last","-3":"3rd last","-4":"4th last"},
        tpl;
      if(options.simple){
        tpl = handleRecurrencyBy(options.freq,["$m on the $d","<on the $d|on the $n $w>","the $W",""]); 
      }else if(options.interval>1){
        tpl = handleRecurrencyBy(options.freq,["Every $i years<, $m on the $d>","Every $i months<, on the $d|, on the $n $w>","Every $i weeks<, the $W>","Every $i days"]); 
      }else{
        tpl = handleRecurrencyBy(options.freq,["Every <$m on the $d|$m on the $n $w|year> ","Every month<, on the $d|, on the $n $w>","Every <$W|week>","Everyday"]);
      }
      var res = replace(tpl,options,daysNumber,monthNames,dayNames,relativeNumber);
      
      if(options.until!==undefined){
        res += ", until "+DateUtils.format(options.until,'LL');
      }
      if(options.count!==undefined){
        res += ", "+options.count+" times";
      }
      return res;
    },
    fr:function(options){
      var 
        dayNames = DateUtils.getWeekDaysRaw(),
        monthNames = [0].concat( DateUtils.getMonthDaysRaw()),
        daysNumber = function(i){
          if(i<-1) return (-i)+"ème dernier jour"; 
          if(i===-1) return "dernier jour"; 
          if(i===1) return "1er"; 
          else return i;
        },
        relativeNumber = {"1":"1ers","2":"2ème","3":"3ème","4":"4ème","-1":"dernier","-2":"2ème dernier","-3":"3ème dernier","-4":"4ème dernier"},
        tpl;
  
      if(options.simple){
        tpl = handleRecurrencyBy(options.freq,["les $d $m>","<le $d|le $n $w>","les $W",""]); 
      }else if(options.interval>1){
        tpl = handleRecurrencyBy(options.freq,["Tous les $i ans<, les $d $m>","Tous les $i mois<, le $d|, le $n $w>","Toutes les $i semaines<, les $W>","Tous les $i jours"]); 
      }else{
        tpl = handleRecurrencyBy(options.freq,["Tous les <$d $m|$n $W de $m|ans>","Tous les mois<, le $d|, le $n $w>","<Tous les $W|Toutes les semaines>","Tous les jours"]);
      }
      var res = replace(tpl,options,daysNumber,monthNames,dayNames,relativeNumber);
      if(options.until!=undefined){
        res += ", jusqu'au "+DateUtils.format(options.until,'LL');
      }
      if(options.count!=undefined){
        res += ", "+options.count+" fois";
      }
      return res;

    },
    sq:function(options){
      var 
        dayNames = DateUtils.getWeekDaysRaw(),
        monthNames = [0].concat( DateUtils.getMonthDaysRaw()),
        daysNumber = function(i){return i},
        //FIXME it is english
        relativeNumber = {"1":"1st","2":"2nd","3":"3rd","4":"4th","-1":"last","-2":"2nd last","-3":"3rd last","-4":"4th last"},
        tpl;
  
      if(options.simple){
        tpl = handleRecurrencyBy(options.freq,["në $d $m","<në $d|në $n $w>","les $w",""]); 
      }else if(options.interval>1){
        tpl = handleRecurrencyBy(options.freq,["Çdo $i vjet<, në $d $m>","Çdo $i muaj< në $d| në $n $w>","Çdo $i javë<, les $w>","Çdo $i ditë"]); 
      }else{
        tpl = handleRecurrencyBy(options.freq,["Çdo <$d $m|vjet>","Çdo muaj< në $d>","Çdo <$w|javë>","Çdo ditë"]);
      }
      var res = replace(tpl,options,daysNumber,monthNames,dayNames,relativeNumber);
      
      if(options.until!==undefined){
        res += ", deri më "+DateUtils.format(options.until,'LL');
      }
      if(options.count!==undefined){
        res += ", "+options.count+" herë";
      }
      return res;

    },
    pt:function(options){
      var 
        dayNames = DateUtils.getWeekDaysRaw(),
        monthNames = [0].concat( DateUtils.getMonthDaysRaw()),
        daysNumber = function(i){
          if(i<-2) return (-i)+"° últimos dias"
          if(i===-2) return "penúltimos dias"
          if(i===-1) return "últimos dias"
          return i
        },
        relativeNumber = {"1":"1°","2":"2°","3":"3°","4":"4°","-1":"últimos","-2":"penúltimos","-3":"3° últimos","-4":"4° últimos"},
        tpl;
  
      if(options.simple){
        tpl = handleRecurrencyBy(options.freq,["$d $m","<$d|$n $w>","$w",""]); 
      }else if(options.interval>1){
        tpl = handleRecurrencyBy(options.freq,["A cada $i anos<, $d $m>","A cada $i mês<, $d|, $n $w>","A cada $i semanas<, $w>","A cada $i dias"]); 
      }else{
        tpl = handleRecurrencyBy(options.freq,["Todos os <$d $m|anos>","Todos os meses<, no dia $d>","Todos os <$w|semanas>","Todos os dias"]);
      }
      var res = replace(tpl,options,daysNumber,monthNames,dayNames,relativeNumber);
      
      if(options.until!==undefined){
        res += ", até "+DateUtils.format(options.until,'LL');
      }
      if(options.count!==undefined){
        res += ", "+options.count+" vezes";
      }
      return res;

    },
    es:function(options){
      var 
        dayNames = DateUtils.getWeekDaysRaw(),
        monthNames = [0].concat( DateUtils.getMonthDaysRaw()),
        daysNumber = function(i){
          if(i<-2) return (-i)+"° últimos dias"
          if(i===-2) return "penúltimos dias"
          if(i===-1) return "últimos dias"
          return i
        },
        relativeNumber = {"1":"1°","2":"2°","3":"3°","4":"4°","-1":"últimos","-2":"penúltimos","-3":"3° últimos","-4":"4° últimos"},
        tpl;
  
      if(options.simple){
        tpl = handleRecurrencyBy(options.freq,["el $d $m","<el $d|el $n $w>","los $w",""]); 
      }else if(options.interval>1){
        tpl = handleRecurrencyBy(options.freq,["Cada $i años<, el $d $m>","Cada $i meses<, el $d|el $n $w>","Cada $i semanas<, los $w>","Cada $i días"]); 
      }else{
        tpl = handleRecurrencyBy(options.freq,["todos los <$d $m|años>","Cada meses<, los $d>","<todos los $w|todas las semanas>","todos los días"]);
      }
      var res = replace(tpl,options,daysNumber,monthNames,dayNames,relativeNumber);
      
      if(options.until!==undefined){
        res += ", hasta el "+DateUtils.format(options.until,'LL');
      }
      if(options.count!==undefined){
        res += ", "+options.count+" veces";
      }
      return res;
    },
    it:function(options){
      var 
        dayNames = DateUtils.getWeekDaysRaw(),
        monthNames = [0].concat( DateUtils.getMonthDaysRaw()),
        daysNumber = function(i){
          if(i<-2) return (-i)+"° ultimo giorno"
          if(i===-2) return "penultimo giorno"
          if(i===-1) return "ultimo giorno"
          return i
        },
        relativeNumber = {"1":"1°","2":"2°","3":"3°","4":"4°","-1":"ultimo","-2":"penultimo","-3":"3° ultimo","-4":"4° ultimo"},
        tpl;
  
      if(options.simple){
        tpl = handleRecurrencyBy(options.freq,["il $d $m","<il $d|il $n $w>","$w",""]); 
      }else if(options.interval>1){
        tpl = handleRecurrencyBy(options.freq,["Ogni $i anni<, il $d $m>","Ogni $i mesi<, il $d|il $n $w>","Ogni $i settimane<, il $w>","ogni $i giorni"]); 
      }else{
        tpl = handleRecurrencyBy(options.freq,["Ogni <$d $m|años>","Ogni mesi<, il $d>","Ogni $w","Quotidiano"]);
      }
      var res = replace(tpl,options,daysNumber,monthNames,dayNames,relativeNumber);
      
      if(options.until!==undefined){
        res += ", fino al "+DateUtils.format(options.until,'LL');
      }
      if(options.count!==undefined){
        res += ", "+options.count+" volte";
      }
      return res;
    },
    ja:function(options){
      var 
        dayNames = DateUtils.getWeekDaysRaw(),
        monthNames = [0].concat( DateUtils.getMonthDaysRaw()),
        daysNumber = function(i){return i},
        relativeNumber = {"1":"1°","2":"2°","3":"3°","4":"4°","-1":"先週の","-2":"-2","-3":"-3","-4":"-4"},
        tpl;
  
      if(options.simple){
        tpl = handleRecurrencyBy(options.freq,["毎年$m$d","<$d|$n $w>","$w",""]); 
      }else if(options.interval>1){
        tpl = handleRecurrencyBy(options.freq,["毎$i年<$m$d>","毎$i月<,$d|$n$w>","毎$i週< $w>","毎$i日"]); 
      }else{
        tpl = handleRecurrencyBy(options.freq,["毎< $d$m|年>","毎月< $d>","毎$w","毎日"]);
      }
      var res = replace(tpl,options,daysNumber,monthNames,dayNames,relativeNumber);
      
      if(options.until!==undefined){
        res += DateUtils.format(options.until,'LL')+"まで";
      }
      if(options.count!==undefined){
        res += ", "+options.count+"回";
      }
      return res;
    },
    ru:function(options){
      var 
        dayNames = DateUtils.getWeekDaysRaw(),
        monthNames = [0].concat( DateUtils.getMonthDaysRaw()),
        daysNumber = function(i){return i},
        relativeNumber = {"1":"1°","2":"2°","3":"3°","4":"4°","-1":"последний","-2":"-2","-3":"-3","-4":"-4"},
        tpl;
  
      if(options.simple){
        tpl = handleRecurrencyBy(options.freq,["каждые $d $m","<$d|$n $w>","каждый $w",""]); 
      }else if(options.interval>1){
        tpl = handleRecurrencyBy(options.freq,["каждые $i года<, $d $m>","каждые $i месяца<, $d |, $n $w>","каждые $i недели<, $w >","каждые $i дня"]); 
      }else{
        tpl = handleRecurrencyBy(options.freq,["каждые <$d $m|$n $w $m|года>","каждый месяц< $d | $n $w>","<каждый $w|каждую неделю>","ежедневно"]);
      }
      var res = replace(tpl,options,daysNumber,monthNames,dayNames,relativeNumber);
      
      if(options.until!==undefined){
        res += "до "+DateUtils.format(options.until,'LL');
      }
      if(options.count!==undefined){
        res += ", "+options.count+" раз";
      }
      return res;
    },
    de:function(options){
      var 
        dayNames = DateUtils.getWeekDaysRaw(),
        monthNames = [0].concat( DateUtils.getMonthDaysRaw()),
        daysNumber = function(i){
          if(i<-1) return (-i)+"° letzte Tage"
          if(i===-1) return "letzte Tage"
          return i
        },
        relativeNumber = {"1":"zuerst","2":"zweite","3":"dritte","4":"vierte","-1":"letzte","-2":"zweite letzte","-3":"dritte letzte","-4":"vierte letzte"},
        tpl;
  
      if(options.simple){
        tpl = handleRecurrencyBy(options.freq,["$d $m","<$d|der $n $w>","$w",""]); 
      }else if(options.interval>1){
        tpl = handleRecurrencyBy(options.freq,["Jedes $i Jahren<, $d $m>","Jede $i Monat<, $d|, der $n $w>","Jede $i Wochen<, $w>","Jede $i Tage"]); 
      }else{
        tpl = handleRecurrencyBy(options.freq,["Jeden <$d $m|Jahre>","Jeden <$d des Monats|$n $w im Monat|Monat>","<Jeden $w|Jede Woche>","Täglich"]);
      }
      var res = replace(tpl,options,daysNumber,monthNames,dayNames,relativeNumber);
      
      if(options.until!==undefined){
        res += ", bis "+DateUtils.format(options.until,'LL');
      }
      if(options.count!==undefined){
        res += ", "+options.count+" mal";
      }
      return res;

    }
    
  }
  
  
  function write(options){
    try{
      var 
        locale = Locale.get(),
        localeBegin = locale.length>2?locale.substring(0,2):locale;
      if(byLang[locale]){
        return byLang[locale](options);
      }else if(byLang[localeBegin]){
        return byLang[localeBegin](options);
      }else{
        return byLang['en'](options);
      }
    }catch(e){
      console.log(e);
      return '';
    }
  }

export {write};